export default {
  homepage: "01ry3j6t00hx4g7SNRHJkYIdKZq96KTPRhEPtV01Ly11hI",
  features: "gjP02Mg3tkjciWhMwQmfqn02chqfSCinFLKeTCKvqSBJY",
  weddings: "ZlDVMkHgd5BQrxtc3RZrkZHa8r6I01WAHI7y7cU5LmZk",
  foodDrink: "ScuZbTVSFTtlu02k4N0000n9Wmw8lH6W5NMjQvH71iBxDg",
}
